<script lang="ts" setup>
	import type { BenefitHighlightContext } from '~/components/molecules/benefit-highlight.vue'

	const props = withDefaults(
		defineProps<{
			title: string
			description: string
			tabsCategory?: Record<string, BenefitHighlightContext>
			staffList?: BenefitHighlightContext
			businessManager?: BenefitHighlightContext
		}>(),
		{
			staffList: () => [
				{
					title: 'Network of hospitals in all 36 states!',
					description:
						'With access to over 1,000 hospitals nationwide, your team can access healthcare whenever, wherever.',
					image: '/v1727082910/nationwide-coverage_yw1euf.webp',
					open: true
				},
				{
					title: '24/7 Hospital support',
					description: 'Count on us to provide necessary support during hospital visits.',
					image: '/v1727082907/hospital-support_xr6aav.webp'
				},
				{
					title: 'Telemedicine',
					description: 'Your staff can connect virtually to medical doctors.',
					image: '/v1727082909/telemedicine_cg7h69.webp'
				},
				{
					title: 'Digital HMO ID',
					description: 'With our digital HMO ID, your staff can access healthcare anytime.',
					image: '/v1727082909/digital-hmo_hcvix7.webp'
				},
				{
					title: 'Employee Mobile App',
					description:
						"Whether they're at work or on the move, your team can manage their plan, find a hospital, or talk to a doctor without delays all from the MyCover app.",
					image: '/v1761840729/mobile-community-2_uroket.webp'
				}
			],
			businessManager: () => [
				{
					title: 'All-in-one business dashboard',
					description: 'With our platform, you can easily manage your plans, staff and claims in real time.',
					bg: '#FFCA99',
					image: '/v1727124316/business-tag_pz8yy0.webp',
					open: true
				},
				{
					title: 'Dedicated account manager',
					description: 'Get personalised support and assistance from your dedicated account manager.',
					image: '/v1727360301/contact-support_lng8hy.webp',
					open: false
				},
				{
					title: 'Usage History',
					description:
						'View transaction history from your account dashboard, including premium payments, employee utilization, and renewals.',
					image: '/v1727360302/comprehensive-plan_rg3rrv.webp',
					open: false
				},
				{
					title: 'Batch operations',
					description:
						"Our batch processing feature enables you to upload your entire team's information in one go, saving you time and effort.",
					image: '/v1727360302/upload-staff_wwgew7.webp',
					open: false
				}
				// {
				// 	title: 'Delegate like a genius',
				// 	description: 'Assign roles and permissions to trusted teammates. Share the control, not the stress.',
				// 	image: '/v1727360299/onboard-manager_hczuhj.webp',
				// 	open: false
				// },
				// {
				// 	title: 'Flexible plans and staff management',
				// 	description: 'Add and remove staff when they join or switch to a new plan with a few clicks.',
				// 	image: '/v1727360302/manage-plan_ifusiw.webp',
				// 	open: false
				// }
			]
		}
	)

	const tabsCategory = ref<Record<string, BenefitHighlightContext>>({
		'For your staff': [],
		'For business managers': []
	})

	const selectedTab = shallowRef('For your staff')
	const { isMobile } = useMobile()
	const list = computed(() => (isMobile.value ? ['For your staff', 'For managers'] : Object.keys(tabsCategory.value)))

	const selectedCategory = computed(() => {
		const key = selectedTab.value === 'For managers' ? 'For business managers' : selectedTab.value
		return tabsCategory.value[key]
	})

	onMounted(() => {
		if (props.tabsCategory && Object.values(props.tabsCategory)[0].length > 0) {
			tabsCategory.value = props.tabsCategory
		}
		tabsCategory.value['For your staff'] = props.staffList
		tabsCategory.value['For business managers'] = props.businessManager
	})
</script>

<template>
	<div>
		<main-benefit-description
			large-on-mobile
			:highlighted-benefits="selectedCategory"
			:title
			:ui="{ li: { activeClass: 'border-health-500', activeText: 'text-health-500' } }"
		>
			<div class="max-w-[712px] w-full text-center mx-auto flexed flex-col mt-5">
				<p class="lg:text-xl md:text-lg text-base text-gray-600 font-normal">
					{{ description }}
				</p>
			</div>

			<client-only>
				<ui-tab-group
					:list="list"
					v-model:value="selectedTab"
					:ui="{
						tabProps: {
							wrapper: 'flex-none mt-10 md:mt-20',
							list: {
								base: 'w-full tracking-wider rounded-[48px] border  border-health-500 bg-health-100',
								height: '',
								rounded: 'rounded-[20px]',
								marker: {
									base: 'min-h-[40px]',
									rounded: 'rounded-[20px]',
									background: 'bg-health-500'
								},
								tab: {
									height: 'min-h-[40px]',
									active: 'text-white font-semibold',
									inactive: 'font-medium',
									shadow: '',
									size: 'text-xs'
								}
							}
						}
					}"
				>
					<template #default="{ index, item, selected }">
						<div class="flex w-full h-full items-center gap-x-2 md:gap-x-3 justify-center">
							<tools-icon
								:dir="selected || index === 0 ? 'fill' : 'line'"
								:icon="index === 0 ? 'people' : 'briefcase'"
								:path-class="`${selected ? 'fill-white' : index === 0 ? 'fill-gray-400' : ''}`"
							/>
							{{ item.label }}
						</div>
					</template>
				</ui-tab-group>
			</client-only>
		</main-benefit-description>
	</div>
</template>
